<template>
  <div>
    <loading
      loader="dots"
      :height="170"
      :width="170"
      color="#3282b8"
      background-color="#505273"
      transition="fade"
      :active="isLoading"
      :is-full-page="true"
    ></loading>
    <div v-if="jkkp === 6">
      <h4 class="info-text">BAHAGIAN C - Huraian kemalangan atau kejadian berbahaya</h4>
      <div class="row justify-content-center">
        <div class="col-sm-10">
          <textarea class="address"
            @change="getUpdate"
            v-model="inDetail"
            placeholder="Sila huraikan apa yang berlaku sebelum, semasa dan selepas kejadian."
          ></textarea>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col text-center">
          <base-button @click="submit()">Finish</base-button>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-lg-6">
          <h4 class="info-text">BAHAGIAN C - Keracunan Pekerjaan / Penyakit</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <base-input label="Diagnosis / Diagnosis Sementara" v-model="doc.diagnosis" ></base-input>
              <base-input label="Select Date">
                <el-date-picker v-model="doc.diagnosis_date" type="date"></el-date-picker>
              </base-input>
              <base-input label="Nama Doktor" v-model="doc.name"></base-input>
              <base-input label="Alamat Doktor" >
                <textarea class="address" v-model="doc.addr"></textarea>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-lg-6" style="border-left: solid red">
          <h4 class="info-text">BAHAGIAN D</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <textarea
                @change="getUpdate"
                v-model="inDetail"
                class="huraian"
                placeholder="Huraian pekerjaan yang membawa kepada keracunan pekerjaan / penyakit pekerjaan (Sila huraikan sebarang kerja
  yang dibuat oleh orang yang terlibat yang mungkin telah membawa kepada penyakit. Jika mungkin disebabkan oleh pendedahan kepada sebarang agen semasa kerja, contoh kimia yang spesifik - sila nyatakan agen berkenaan). "
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <!-- <div class="col text-center"> -->
          <base-button @click="submit()" :disabled="dis">Finish</base-button>
          <div class="d-flex justify-content-center spinner" v-if="load">
            <circle-8></circle-8>
          </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    Loading,
    Circle8
  },
  data() {
    return {
      isLoading: false,
      dis: false,
      load: false,
      inDetail: "",
      value1: "",
      tableSiteRoute: [
        {
          siteRoute: "Route A"
        },
        {
          siteRoute: "Route B"
        }
      ],
      selects: {
        condition: [
          { value: "operational", label: "Operational" },
          { value: "Not operational", label: "Not Operational" }
        ]
      },
      model: {
        file: null
      },
      idrecord: "",
      notifier: {
        name: "",
        designation: "",
        org: "",
        phoneno: "",
        add: "",
        roc: "",
        jkkpregno: "",
        other: ""
      },
      victim: {
        name: "",
        dob: "",
        kp: "",
        org: "",
        nopekerja: "",
        nationality: "",
        gender: "",
        occupation: "",
        inlocation: "",
        orgaddr: "",
        intimestamp: "",
        reportdate: ""
      },
      doc:{
        diagnosis: "",
        diagnosis_date: "",
        name: "",
        addr: "",
      },
      jkkp: "",
      inTime: "",
      inLocation: "",
      medic:{
        name: "",
        designation: "",
        telNo: "",
        addr: ""
      }
      // indetails: "",
    };
  },
  mounted() {
    this.noDataChanges()
    this.$root.$on("senddata", data => {
      // do your thing
      let response = data[0]
      console.log(response)
      // console.log("changes")
      this.inDetail = response.inDetail;
      this.inTime = response.inTime;
      this.inLocation = response.inLocation;
      this.jkkp = response.jkkp;
      
      this.idrecord = response.incidentId;
      this.notifier.name = response.notifierName;
      this.notifier.designation = response.notifierDesignation;
      this.notifier.org = response.notifierOrg;
      this.notifier.phoneno = response.notifierTelNo;
      this.notifier.add = response.notifierAddr;
      this.notifier.roc = response.notifierRocNo;
      this.notifier.jkkpregno = response.notifierJkkpRegNo;
      this.notifier.other = response.otherContact;
      this.victim.name = response.personInvolved;
      this.victim.dob = response.vicDob;
      this.victim.kp = response.vicKp;
      this.victim.nopekerja = response.NoPekerja;
      this.victim.nationality = response.vicNation;
      this.victim.gender = response.vicSex;
      this.victim.occupation = response.vicOccupation;
      this.victim.inlocation = response.incidentLocation;
      this.victim.orgaddr = response.vicCompAddr;
      this.victim.org = response.vicOrg;
      this.victim.intimestamp = response.dateOfIncident;
      this.victim.reportdate = response.reportDateToJkkp;

      this.medic.name = response.medicName;
      this.medic.designation = response.medicDesignation;
      this.medic.telNo = response.medicTelNo;
      this.medic.addr = response.medicAddr;
      this.doc.diagnosis = response.docDiagnosis;
      this.doc.diagnosis_date = response.docDiagnosisDate;
      this.doc.name = response.docName;
      this.doc.addr = response.docAddr;
    });
  },
  methods: {
    onFileChange(file) {
      this.file = file;
    },
    validate() {
      this.$emit("on-validated", true, this.model);
      return Promise.resolve(true);
    },
    getUpdate() {
      console.log(this.inDetail);
      console.log(this.idrecord);
      console.log(this.notifier.name);
      console.log(this.notifier.designation);
      console.log(this.notifier.org);
      console.log(this.notifier.phoneno);
      console.log(this.notifier.add);
      console.log(this.notifier.roc);
      console.log(this.notifier.jkkpregno);
      console.log(this.notifier.other);

      console.log(this.victim.name);
      console.log(this.victim.dob);
      console.log(this.victim.kp);
      console.log(this.victim.nopekerja);
      console.log(this.victim.nationality);
      console.log(this.victim.gender);
      console.log(this.victim.occupation);
      console.log(this.victim.inlocation);
      console.log(this.victim.orgaddr);
      console.log(this.victim.intimestamp);
      console.log(this.victim.reportdate);
      console.log(this.victim.org)
      console.log(this.inDetail);

      console.log(this.medic.name)
      console.log(this.medic.designation)
      console.log(this.medic.telNo)
      console.log(this.medic.addr)

    },
    noDataChanges(){
      this.$root.$on('update', row => {
        console.log(row)
        console.log("nochanges")
         console.log(row.jkkp);
      (this.jkkp = row.jkkp);
      console.log(this.jkkp);
      (this.idrecord = row.incidentId), 
      (this.notifier.name = row.notifierName);
      (this.notifier.designation = row.notifierDesignation),
      (this.notifier.org = row.notifierOrg),
      (this.notifier.phoneno = row.notifierTelNo),
      (this.notifier.add = row.notifierAddr),
      (this.notifier.roc = row.notifierRocNo),
      (this.notifier.jkkpregno = row.notifierJkkpRegNo),
      (this.notifier.other = row.otherContact);

      (this.victim.name = row.personInvolved),
      (this.victim.dob = row.vicDob),
      (this.victim.kp = row.vicKp),
      (this.victim.nopekerja = row.NoPekerja),
      (this.victim.nationality = row.vicNation),
      (this.victim.gender = row.vicSex),
      (this.victim.occupation = row.vicOccupation),
      (this.victim.inlocation = row.incidentLocation),
      (this.victim.orgaddr = row.vicCompAddr),
      (this.victim.intimestamp = row.dateOfIncident),
      (this.victim.reportdate = row.reportDateToJkkp),
      (this.victim.org = row.vicOrg);
      (this.inDetail = row.inDetail),
      (this.inTime = row.inTime),
      (this.inLocation = row.inLocation);
      (this.medic.name = row.medicName);
      (this.medic.designation = row.medicDesignation);
      (this.medic.telno = row.medicTelNo);
      (this.medic.addr = row.medicAddr);
      (this.doc.diagnosis = row.diagnosis);
      (this.doc.diagnosis_date = row.diagnosisDate);
      (this.doc.name = row.doctorName);
      (this.doc.addr = row.doctorAddr);
      })
    },
    submit() {
      this.load = true;
      this.isLoading = true;
      console.log("belom submit");
      console.log(this.idrecord);
      console.log(this.notifier.name);
      console.log(this.notifier.designation);
      console.log(this.notifier.org);
      console.log(this.notifier.phoneno);
      console.log(this.notifier.add);
      console.log(this.notifier.roc);
      console.log(this.notifier.jkkpregno);
      console.log(this.notifier.other);

      console.log(this.victim.name);
      console.log(this.victim.dob);
      console.log(this.victim.kp);
      console.log(this.victim.nopekerja);
      console.log(this.victim.nationality);
      console.log(this.victim.gender);
      console.log(this.victim.occupation);
      // console.log(this.victim.inlocation);
      console.log(this.victim.orgaddr);
      console.log(this.victim.intimestamp);
      console.log(this.victim.reportdate);
      console.log(this.victim.org)
      console.log(this.inLocation)
      console.log(this.inTime)
      console.log(this.inDetail);

      console.log(this.medic.name)
      console.log(this.medic.designation)
      console.log(this.medic.telNo)
      console.log(this.medic.addr)

      console.log(this.doc.diagnosis)
      console.log(this.doc.diagnosis_date)
      console.log(this.doc.name)
      console.log(this.doc.addr)

      let timestamp = this.victim.intimestamp + " " + this.inTime
      console.log(timestamp)
      let newTime = moment.utc(timestamp).format()
      console.log(newTime)

      let obj = {
        InDate: newTime,
        NameOfNotifier: this.notifier.name,
        VictimName: this.victim.name,
        NotifierDesignation: this.notifier.designation,
        NotifierOrg: this.notifier.org,
        NotifierAddr: this.notifier.add,
        NotifierTelNo: this.notifier.phoneno,
        NotifierRocNo: this.notifier.roc,
        NotifierJkkpRegNo: this.notifier.jkkpregno,
        OtherContactInfo: this.notifier.other,
        VicDob: this.victim.dob,
        VicKp: this.victim.kp,
        VicNation: this.victim.nationality,
        VicSex: this.victim.gender,
        VicOccupation: this.victim.occupation,
        VicComp: this.victim.org,
        // IncidentLocation: this.victim.inlocation,
        VicCompAddr: this.victim.orgaddr,
        ReportDateToJkkp: this.victim.reportdate,
        InDetail: this.inDetail,
        InLocation: this.inLocation,
        MedicName: this.medic.name,
        MedicDesignation: this.medic.designation,
        MedicTelNo: this.medic.telNo,
        MedicCompAddr: this.medic.addr,
        Diagnosis: this.doc.diagnosis,
        DiagnosisDate: this.doc.diagnosis_date,
        DoctorName: this.doc.name,
        DoctorAddr: this.doc.addr
      };
      if (this.idrecord === "") {
        swal({
          title: "Nothing to submit!",
          text: "No changes made",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false
        });
      } else {
        // if(this.jkkp === )
      this.$http.put(":9994/api/v1/incident/record/"+ this.idrecord , obj)
        .then(res=>{
          if(!res.error){
            this.load = false
            this.isLoading = false
            swal({
              title: "Successfull!",
              text: `${res.message}`,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false
            }).then(okay => {
            if (okay) {
              // window.location.href = "URL";
              console.log("ok")
              this.$router.go()

            }
            })
            
            
            // this.$router.push({ path: `/IncidentReport/UpdateJKKP/` });
          } else {
            this.load = false
            this.isLoading = false
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false
            });
          }
        })
      
      }
    }
    // this.model = row
  }
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.address {
  width: 100%;
  height: 300px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
